import React from 'react';
import './EmergencyOverlay.css';

const EmergencyOverlay = ({ isActive, onClose }) => {
  if (!isActive) return null;

  return (
    <div className="emergency-overlay active">
      <div className="emergency-grid"></div>
      <div className="emergency-glitch"></div>
      
      <div className="emergency-content">
        <h1 className="emergency-title">EMERGENCY</h1>
        <h2 className="emergency-subtitle">SOS ALERT SENDING</h2>
        <p className="emergency-status">CONNECTING TO EMERGENCY SERVICES...</p>
      </div>
      
      <div className="emergency-symbols">🚨</div>
      <div className="emergency-warning">⚠️ EMERGENCY ⚠️</div>
      
      {/* 3D Floating Particles */}
      <div className="emergency-particles">
        <div className="particle particle-1">🚨</div>
        <div className="particle particle-2">⚠️</div>
        <div className="particle particle-3">🚨</div>
        <div className="particle particle-4">⚠️</div>
        <div className="particle particle-5">🚨</div>
      </div>
      
      <div className="emergency-overlay-controls">
        <button 
          className="emergency-close-btn" 
          onClick={onClose}
          style={{
            position: 'absolute',
            bottom: '20px',
            right: '20px',
            background: 'rgba(255, 255, 255, 0.1)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            color: 'white',
            padding: '10px 20px',
            cursor: 'pointer',
            fontSize: '1rem'
          }}
        >
          CLOSE
        </button>
      </div>
    </div>
  );
};

export default EmergencyOverlay;
